var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3283_2115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9999C18.6274 23.9999 24 18.6273 24 11.9999C24 5.37246 18.6274 -0.00012207 12 -0.00012207C5.37258 -0.00012207 0 5.37246 0 11.9999C0 18.6273 5.37258 23.9999 12 23.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4785 12H24.0002C24.0002 10.9169 23.8559 9.86762 23.5868 8.86951H11.4785V12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4785 5.7391H22.239C21.5044 4.54041 20.5651 3.48089 19.47 2.60864H11.4785V5.7391Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 23.9999C14.8252 23.9999 17.421 23.0238 19.4709 21.3912H4.53125C6.58109 23.0238 9.17689 23.9999 12.0011 23.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76195 18.2608H22.2394C22.8291 17.2985 23.2865 16.2467 23.5873 15.1304H0.414062C0.714859 16.2467 1.17222 17.2985 1.76195 18.2608Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55863 1.87385H6.65217L5.63498 2.61283L6.02353 3.80857L5.00639 3.06958L3.98925 3.80857L4.32487 2.77558C3.42928 3.5216 2.64431 4.39563 1.99744 5.3695H2.34783L1.70034 5.83989C1.59947 6.00817 1.50272 6.17913 1.41 6.35261L1.71919 7.30422L1.14234 6.88511C0.998953 7.18891 0.867797 7.49955 0.749906 7.81666L1.09055 8.86516H2.34783L1.33064 9.60414L1.71919 10.7999L0.702047 10.0609L0.0927656 10.5036C0.0317812 10.9938 0 11.4931 0 11.9999H12C12 5.3725 12 4.59119 12 -0.00012207C9.62944 -0.00012207 7.41961 0.687534 5.55863 1.87385ZM6.02353 10.7999L5.00639 10.0609L3.98925 10.7999L4.3778 9.60414L3.36061 8.86516H4.61789L5.00639 7.66943L5.39489 8.86516H6.65217L5.63498 9.60414L6.02353 10.7999ZM5.63498 6.10849L6.02353 7.30422L5.00639 6.56524L3.98925 7.30422L4.3778 6.10849L3.36061 5.3695H4.61789L5.00639 4.17377L5.39489 5.3695H6.65217L5.63498 6.10849ZM10.3279 10.7999L9.31073 10.0609L8.29359 10.7999L8.68214 9.60414L7.66495 8.86516H8.92223L9.31073 7.66943L9.69923 8.86516H10.9565L9.93933 9.60414L10.3279 10.7999ZM9.93933 6.10849L10.3279 7.30422L9.31073 6.56524L8.29359 7.30422L8.68214 6.10849L7.66495 5.3695H8.92223L9.31073 4.17377L9.69923 5.3695H10.9565L9.93933 6.10849ZM9.93933 2.61283L10.3279 3.80857L9.31073 3.06958L8.29359 3.80857L8.68214 2.61283L7.66495 1.87385H8.92223L9.31073 0.678112L9.69923 1.87385H10.9565L9.93933 2.61283Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3283_2115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.aaa5d283e763b525d39af1be5e20effb.svg";
export { ForwardRef as ReactComponent };